export default __webpack_public_path__ + "static/media/gujarati-card-bg.e7127080.svg";